
export default {
  data() {
    return {
      pageData: null,
      searchTerm: "",
    };
  },
  methods: {
    async supportSearch() {
      if (this.$i18n.locale === "en") {
        await this.$router.push({
          path: "/search-results",
          query: {
            posttype: "helpdesk",
            keyword: this.searchTerm,
          },
        });
      } else {
        await this.$router.push({
          path: "rezultati-pretrage",
          query: {
            posttype: "helpdesk",
            keyword: this.searchTerm,
          },
        });
      }
    },
  },
};
